module.exports = __webpack_public_path__ + "static/media/logo_long.8ef6b34b.svg";